import { ElementType } from 'react'

import { Text, TextProps } from '@lounge-fe/ui-kit/src/components/Text'

const Body = <E extends ElementType = 'p'>(props: TextProps<E>) =>
  props.children ? <Text variant="body-md" {...props} /> : null

export default Body
